/* eslint sort-keys: "error" */
export default {
  appStoreBadgeClicked: 'app store badge clicked',
  arbitration: {
    arbSubmitClicked: 'arb submit clicked',
    categoryClicked: 'arb category clicked',
    complaintAdded: 'arb complaint added',
    complaintDeleted: 'arb complaint deleted',
    deleteComplaintClicked: 'arb delete complaint clicked',
    editComplaintClicked: 'arb edit complaint clicked',
    error: 'arb error occurred',
    evidenceAdded: 'arb evidence added',
    evidenceRemoved: 'arb evidence removed',
    evidenceUploadCompleted: 'arb evidence upload completed',
    odometerCancelClicked: 'arbitration odometer cancel clicked',
    odometerCompleted: 'arbitration odometer completed',
    odometerNextClicked: 'arbitration odometer next clicked',
    odometerStarted: 'arbitration odometer started',
    submitEvidenceClicked: 'arbitration submit evidence clicked',
    timelineUploadClicked: 'arbitration timeline upload clicked',
  },
  arbitrationPolicyViewed: 'arbitration policy viewed',
  arbitrationSubmitted: 'arb submitted',
  auctionAccess: {
    alerts: {
      dialogClosed: 'auction access account alerts dialog closed',
      dialogShown: 'auction access account alerts dialog shown',
      dialogSubmitted: 'auction access account alerts dialog submit button clicked',
    },
    dealershipSelection: {
      backButtonClicked: 'auction access dealership selection back button clicked',
      dealershipIssues: 'auction access dealership issues viewed',
      dealershipRegistrationBlockingIssuesFound: 'auction access registration blocking issues found',
      dealershipSelectedError: 'auction access dealership lead creation error',
      dealershipSelectedSuccess: 'auction access dealership lead creation success',
      dealershipsEligibleForRegistration: 'auction access dealerships eligible for registration found',
      viewed: 'auction access dealership selection viewed',
    },
    form: {
      backButtonClicked: 'auction access form back button clicked',
      formSubmittedError: 'auction access account information retrieval error',
      formSubmittedSuccess: 'auction access account information retrieval success',
      viewed: 'auction access form viewed',
    },
    preRegistration: {
      auctionAccessAccountRegistrationLinkClicked: 'auction access account registration link clicked',
      continueWithAuctionAccessClicked: 'auction access preregistration clicked',
      viewed: 'auction access preregistration viewed',
    },
    status: {
      issueUpdate: 'auction access issue update status',
      noIssues: 'auction access account has not issues',
    },
  },
  auctionHoldChanged: 'auction hold changed',
  auctionIssueScreenLoaded: 'Auction Issue Screen Loaded',
  auctionLaunched: 'auction launched',
  auctionLaunchedFailed: 'auction launched failed',
  auctionListUpdatedNotificationLinkClicked: 'auction list updated notification link clicked',
  auctionPurchasedNow: 'buy now auction purchased',
  auctionTitleStatusTracker: 'auction title status track package clicked',
  auctionViewed: 'auction viewed',
  audioPlaybackEnded: 'amp playback ended',
  audioPlaybackPaused: 'amp playback paused',
  audioPlaybackStarted: 'amp playback started',
  bidClicked: 'bid clicked',
  bidFailed: 'bid failed',
  bidPlaced: 'bid placed',
  bidWindowClosed: 'bid window closed',
  breadcrumbLinkClicked: 'breadcrumb link clicked',
  buyingSystemLinkClicked: 'buying system link clicked',
  buyingTabViewed: 'buying tab viewed',
  capital: {
    checkout: {
      advantageDisplayed: 'capital advantage checkout displayed',
      advantageProductSelection: 'capital advantage checkout product selection',
      advantageTCLink: 'capital advantage terms and conditions clicked',
      error: 'capital checkout error',
      floorplanDisplayed: 'capital floorplan checkout displayed',
      floorplanProductSelection: 'capital floorplan checkout product selection',
      floorplanTermSelected: 'capital floorplan checkout term selected',
      missingPaymentMethods: 'capital missing payment methods',
      utilizationPresented: 'capital utilization message presented',
    },
    ineligibleVehicle: 'capital ineligible vehicle',
    landing: {
      salesRepURLAccessed: 'capital landing page URL accessed',
    },
    leadGen: 'capital lead gen presented',
    leadGenApiFailureError: 'capital lead gen api failure error msg',
    leadGenLearnMore: 'capital lead gen clicked learn more',
    leadGenRequestMore: 'capital lead gen clicked request more',
    leadGenTCErrorMsg: 'capital lead gen t&c error msg',
    openApplicationForm: 'capital application apply clicked',
    outOfRange: 'capital out of range',
    portal: {
      enterPortal: 'capital portal entered',
      errorPagePresented: 'capital portal error page presented',
      existsRetry: 'capital portal exists retry',
    },
  },
  carfax: {
    carfaxLoginTriggered: 'carfax login triggered',
    carfaxLogout: 'carfax logout',
    carfaxRedirectFailed: 'carfax redirect failed',
    carfaxRedirectSuccess: 'carfax redirect success',
    carfaxReportAuthError: 'carfax report auth error',
    carfaxReportAuthSuccess: 'carfax report auth success',
    carfaxReportNotFound: 'carfax report not found',
    carfaxReportPurchased: 'carfax report purchased',
    carfaxReportViewed: 'carfax viewed',
  },
  clearCarAppraisalLinkClicked: 'clearcar appraisal link clicked',
  clockDrift: 'clock drift',
  counterOfferSent: 'Counter offer sent',
  crPreviewOpened: 'cr preview opened',
  creditBannerInfoHover: 'credit banner info hover',
  crossLanePromotion: {
    crossLaneCollapsed: 'cross lane collapsed',
    crossLaneExpanded: 'cross lane expanded',
    crossLaneViewMore: 'cross lane view more',
  },
  dealerDocs: {
    registerDocumentClicked: 'register document upload clicked',
    registerDocumentFailed: 'register document failed',
    registerDocumentFormDownloaded: 'register document form downloaded',
    registerDocumentUploaded: 'register document uploaded',
  },
  dealerNetworkBidDetailsHovered: 'dealer network bid details hovered',
  deploymentReloadPromptClicked: 'deployment reload prompt clicked',
  deploymentReloadPromptSeen: 'deployment reload prompt seen',
  deprecationBannerClicked: 'deprecation banner clicked',
  digitalRunSheet: {
    editClicked: 'request inspection edit clicked',
    failedValidation: 'request inspection validation failure',
    navigatedBack: 'request inspection back clicked',
    navigatedForward: 'request inspection next clicked',
    startedNewOrResumed: 'request inspection new clicked',
    startedOver: 'request inspection start over clicked',
    submitted: 'inspection request submitted',
    viewedSubmittedRequests: 'request inspection requested clicked',
  },
  dnsForm: {
    saveClicked: 'save dns form clicked',
  },
  featureFlagsUpdated: 'feature flags updated',
  filterCleared: 'filter cleared',
  filtersWindowOpened: 'Filters window opened',
  finalizeOptionsViewed: 'checkout page viewed',
  fleetLeaseBadgeClicked: 'fleet lease badge clicked',
  footer: {
    dealerFormsLinkClicked: 'footer dealer documents clicked',
    facebookClicked: 'footer facebook clicked',
    instagramClicked: 'footer instagram clicked',
    legalLinkClicked: 'footer legal clicked',
    linkedinClicked: 'footer linkedin clicked',
    privacyPolicyLinkClicked: 'footer privacy policy clicked',
    supportLinkClicked: 'footer support clicked',
    termsOfServiceLinkClicked: 'footer terms of service clicked',
    twitterClicked: 'footer twitter clicked',
  },
  forgotPasswordClicked: 'forgot password link clicked',
  forgotPasswordLoginClicked: 'forgot password return to login clicked',
  fullConditionReportViewed: 'full cr viewed',
  googlePlayStoreBadgeClicked: 'google play store badge clicked',
  googlePrivacyPolicyClicked: 'google recaptcha privacy policy link clicked',
  googleRecaptchaRequestFailed: 'failed to obtain google recaptcha token',
  googleTermsOfServiceClicked: 'google recaptcha terms of service link clicked',
  headerLinkClicked: 'header link clicked',
  jwtEmbed: {
    error: 'JWT wrapper for native error on initialization',
    logging: 'JWT wrapper for native debug logging',
  },
  loginClicked: 'log in clicked',
  loginFailed: 'log in failed',
  loginSuccess: 'logged in',
  makeOfferCancel: 'offer window closed',
  makeOfferConfirmCancel: 'Make offer confirm cancel clicked',
  makeOfferConfirmOk: 'Make offer confirm ok clicked',
  makeOfferFailed: 'make offer failed',
  makeOfferModalViewed: 'make offer modal viewed',
  makeOfferOk: 'make offer button clicked',
  makeOfferOpenClicked: 'make offer open clicked',
  makeOfferSortBy: 'make offer sort by',
  malformedRefreshToken: 'malformed refresh token found',
  manageProxySettingsClicked: 'manage proxy settings clicked',
  managedUsersAddedUser: 'user added',
  managedUsersUserAddFailed: 'user add attempted but failed',
  marketReportComparableOpened: 'market report auction clicked',
  marketReportFaqClicked: 'market report faq clicked',
  marketReportFilterChanged: 'market report filter changed',
  marketReportSearched: 'market report searched',
  marketReportTabViewed: 'market report tab viewed',
  marketReportViewed: 'market report viewed',
  marketing: {
    imageClicked: 'login marketing carousel image cta clicked',
    nextSlideNavigated: 'login marketing carousel next slide navigated',
    prevSlideNavigated: 'login marketing carousel previous slide navigated',
    quoteClicked: 'login marketing carousel quote cta clicked',
  },
  marketplaceV2: {
    auctionCardModeToggled: 'auction card mode toggled',
    auctionImpression: 'auction impression',
    auctionListingsSelected: 'auction listings selected',
    auctionsSearched: 'auctions searched',
    eulaAccepted: 'eula accepted',
    eulaBannerClicked: 'eula banner clicked',
    eulaBannerDismissed: 'eula banner dismissed',
    eulaDisplayed: 'eula displayed',
    eulaFailedToDisplay: 'eula failed to display',
    eulaIntercepted: 'eula intercepted',
    eulaRetryDisplayClicked: 'eula retry display clicked',
    fastActionPanelToggled: 'fast action panel toggled',
    listingTypeSelected: 'listing type selected',
    marketplaceTabViewed: 'marketplace tab viewed',
    nearReserveBadgeSeen: 'near reserve badge seen',
    recommendationsSeen: 'recommendations seen',
    reserveMetBadgeSeen: 'reserve met badge seen',
    saveFiltersButtonToSavedSearch: 'save filters button to saved search',
    savedSearchesActivated: 'saved searches activated',
    savedSearchesCreateNewClicked: 'saved searches create new clicked',
    savedSearchesDeactivated: 'saved searches deactivated',
    savedSearchesEditClicked: 'saved searches edit clicked',
    searchSaved: 'search saved',
    sendToAuctionOpened: 'Send to auction opened',
    srpClearAllSavedSearches: 'srp clear all saved searches',
    srpClearEventsButtonClicked: 'srp clear events button clicked',
    srpEventsDirectoryClosed: 'srp events directory closed',
    srpEventsDirectoryViewed: 'srp events directory viewed',
    srpLaneClickedFromDirectory: 'srp lane clicked from directory',
    srpLaneToggled: 'srp lane toggled',
    srpMarketplaceBetaSurveyClicked: 'srp marketplace beta survey clicked',
    srpMarketplaceBetaToggled: 'srp marketplace beta toggled',
    srpSimulcastEventViewCanceled: 'srp simulcast event view canceled',
    srpSimulcastEventViewed: 'srp simulcast event viewed',
    srpSortCriteriaChanged: 'srp sort criteria changed',
    srpStatePillClicked: 'srp state pill clicked',
    vdp3Redesign: 'vdp 3 redesign toggled',
    vehicleDetailPageClosed: 'vehicle detail page closed',
    viewMarketReportBadgeClicked: 'view market report badge clicked',
    viewWonAuctionsClicked: 'view won auctions clicked',
    watchlistToggled: 'watchlist toggled',
  },
  myAcvDataExported: 'myacv data exported',
  myAcvExportDataOpened: 'myacv export data opened',
  myAcvFinalized: {
    myAcvSoldFinalizedDealershipLicense: 'my acv sold finalized dealership license downloaded',
    myAcvSoldFinalizedResaleCertificate: 'my acv sold resale certificate license downloaded',
  },
  myAcvOffers: {
    myAcvOffersAcceptFailed: 'myacv offers offer accept failed',
    myAcvOffersDeclineFailed: 'myacv offers offer decline failed',
    myAcvOffersFiltersApplied: 'myacv offers filters applied',
    myAcvOffersNegotiationAcceptConfirmClicked: 'myacv offers negotiation accept confirm clicked',
    myAcvOffersNegotiationAcceptFailed: 'myacv offers negotiation accept failed',
    myAcvOffersNegotiationCounterConfirmClicked: 'myacv offers negotiation counter confirm clicked',
    myAcvOffersNegotiationCounterFailed: 'myacv offers negotiation counter failed',
    myAcvOffersNegotiationDeclineConfirmClicked: 'myacv offers negotiation decline confirm clicked',
    myAcvOffersNegotiationDeclineFailed: 'myacv offers negotiation decline failed',
    myAcvOffersNegotiationViewed: 'myacv offers negotiation viewed',
    myAcvOffersOfferAcceptCancelClicked: 'myacv offers offer accept cancel clicked',
    myAcvOffersOfferAcceptClicked: 'myacv offers offer accept clicked',
    myAcvOffersOfferAcceptConfirmClicked: 'myacv offers offer accept confirm clicked',
    myAcvOffersOfferAcceptFailed: 'myacv offers offer accept failed',
    myAcvOffersOfferDeclineCancelClicked: 'myacv offers offer decline cancel clicked',
    myAcvOffersOfferDeclineClicked: 'myacv offers offer decline clicked',
    myAcvOffersOfferDeclineConfirmClicked: 'myacv offers offer decline confirm clicked',
    myAcvOffersOfferDeclineFailed: 'myacv offers offer decline failed',
    myAcvOffersOfferViewed: 'myacv offers offer viewed',
    myAcvOffersPageChanged: 'myacv offers page changed',
    myAcvOffersRowClicked: 'myacv offers row clicked',
    myAcvOffersRowsPerPageChanged: 'myacv offers rows per page changed',
    myAcvOffersSearched: 'myacv offers searched',
  },
  myAcvRoutesViewed: {
    myAcvSoldUpdatesSkipped: 'user opted out of viewing sold auctions table update tour',
    myAcvSoldUpdatesViewed: 'user viewed myacv sold table view tour',
  },
  myAcvSellerDashboard: {
    dealershipSelected: 'myacv seller dashboard dealership selected',
    graphHover: 'myacv seller dashboard graph hover',
    infoHover: 'myacv seller dashboard info hover',
    insightsDateChanged: 'myacv seller dashboard insights date change',
    titleComplianceToggle: 'myacv seller dashboard title toggle',
  },
  myAcvSoldTour: {
    moreResourcesAvailableStepViewed: 'my acv new sold view second tour step viewed',
    newSoldLayoutTourStepViewed: 'my acv new sold view first tour step viewed',
  },
  myAcvTabViewed: 'myacv tab viewed',
  myAcvWonTable: {
    arbitrationClaimStarted: 'Arbitration Claim Started',
    arbitrationTabClicked: 'Arbitration Tab Clicked',
    finalizeButtonClicked: 'my acv won finalized clicked',
    optionMenuClicked: 'my acv won option clicked',
    optionMenuItemSelected: 'my acv won option selected',
    titleClicked: 'my acv won title clicked',
    transportOffPlatformCtaClicked: 'MyACV Won: transportation offplatform cta clicked',
    transportOffPlatformCtaSeen: 'MyACV Won: transportation offplatform cta seen',
    transportationTabClicked: 'MyACV - Won : transportation subtab clicked',
    vehicleClicked: 'my acv won vehicle clicked',
  },
  myInventory: {
    csvUploaded: 'my inventory csv uploaded',
    dataExported: 'my inventory data exported',
    expiredCRhidden: 'my inventory expired cr hidden',
    gsale: {
      firmOfferViewed: 'my inventory gsale firm offer viewed',
      requestPricing: 'my inventory gsale request pricing',
      sendToGsale: 'my inventory gsale send to gsale',
      submitToGsale: 'my inventory gsale submit to gsale',
      updatePricing: 'my inventory gsale update pricing',
    },
    inspectionRequest: {
      requestSent: 'my inventory inspection request sent',
    },
    launchVehiclesClicked: 'my inventory launch vehicles clicked',
    statusCtaClicked: 'my inventory status clicked',
    statusFiltered: 'my inventory status filtered',
    tableReordered: 'my inventory table reordered',
    viewTypeSwitched: 'my inventory view type switched',
  },
  noNetworkDialogShown: 'No network dialog shown',
  notifications: {
    appLaunchMessageCtaClicked: 'notification app launch message url clicked',
    appLaunchMessageNextNavigated: 'notification app launch message next slide navigated',
    appLaunchMessagePrevNavigated: 'notification app launch message prev slide navigated',
    iconClicked: 'notification icon clicked',
    itemClicked: 'notification item clicked',
    markAllReadClicked: 'notification mark all as read clicked',
    pushNotificationClicked: 'push notification clicked',
    viewAllClicked: 'notification view all clicked',
  },
  offboarding: {
    deactivateAccountClicked: 'deactivate account clicked',
    deactivateAccountConfirmationClicked: 'deactivate account confirmation clicked',
    deactivateAccountReasonClicked: 'deactivate account reason clicked',
    dealershipWinbackActionClicked: 'deactivate account winback support clicked',
    notificationWinbackActionClicked: 'deactivate account winback notification clicked',
  },
  offerAttempt: 'offer attempt failed',
  offerMade: 'offer made',
  opened: 'app opened',
  otherIssuesSubmitted: 'other issues submitted',
  passwordResetRequested: 'requested password reset',
  paymentCompleted: 'payment completed',
  photoCategoryClicked: 'photo category clicked',
  photoGalleryDuration: 'time in photo viewer',
  photoGalleryImagesViewed: 'num photos viewed',
  photoGalleryOpened: 'photo viewer opened',
  photoViewed: 'photo viewed',
  premiumPackagesViewed: 'premium packages viewed',
  pricingAdvisor: {
    launchingPrevented: 'launching prevented',
    pricingReviewSeen: 'acv pricing review seen',
  },
  proxyCanceled: 'proxy canceled',
  proxyEdited: 'proxy edited',
  proxyScheduleClicked: 'proxy schedule clicked',
  proxyScheduleWindowClosed: 'proxy schedule window closed',
  proxyScheduled: 'proxy scheduled',
  refinedClicked: 'refined clicked',
  reportAProblemClicked: 'report a problem clicked',
  resetPasswordClicked: 'reset password button clicked',
  rewardsButtonClicked: 'loyalty dealer rewards program button clicked',
  rewardsEnrollBtnClicked: 'loyalty join for free button clicked',
  rewardsEnrolled: 'loyalty enrollment completed',
  rewardsLoyaltyProgressViewed: 'loyalty rewards progress card viewed',
  rewardsPageViewed: 'loyalty dealer rewards program page viewed',
  savedAuctionDeleted: 'saved auction deleted',
  savedAuctions: {
    gsale: {
      offerFirstShown: 'gsale auction viewed',
    },
  },
  savedSearch: {
    conditionExclusionClicked: 'clicked condition exclusion',
    conditionExclusionViewed: 'viewed condition exclusion',
    matchNotificationForecastUpdateViewed: 'viewed notification forecast update',
    samBuyingRuleClicked: 'clicked SAM buying rule',
    samBuyingRuleViewed: 'viewed SAM buying rule',
    vehicleFilterClicked: 'clicked vehicle filters',
    vehicleFilterViewed: 'viewed vehicle filters',
  },
  scheduledAuctionCancelFailed: 'scheduled auction cancel failed',
  scheduledAuctionCanceled: 'scheduled auction canceled',
  sellingTabViewed: 'selling tab viewed',
  settings: {
    dealershipAddresses: {
      addNewFailure: 'dealership address creation attempted but failed',
      addNewSuccess: 'dealership address added successfully',
      dealershipSelected: 'dealership selected',
      deleteFailure: 'dealership address deletion attempted but failed',
      deleteSuccess: 'dealership address deleted successfully',
      filtersSelected: 'dealership address filters selected',
      paginationNavigated: 'dealership address pagination navigated',
      searchCriteriaApplied: 'dealership address search criteria applied',
      updateFailure: 'dealership address update attempted but failed',
      updateSuccess: 'dealership address updated successfully',
    },
    dealershipContacts: {
      addNewFailure: 'dealership contact creation attempted but failed',
      addNewSuccess: 'dealership contact added successfully',
    },
    manageUsers: {
      deleteFailure: 'user deletion attempted but failed',
      deleteSuccess: 'user deleted successfully',
      passwordResetFailure: 'user password reset attempted but failed',
      passwordResetSuccess: 'user password reset successfully',
    },
    pageViewed: 'settings page viewed',
    settingChanged: 'setting changed',
  },
  shareCopyClicked: 'share copy clicked',
  signUpLinkClicked: 'registration sign up link clicked',
  sortEndedList: 'sort ended list',
  startAnArbClicked: 'start an arb clicked',
  tabLinkClicked: 'tab link clicked',
  titleHub: {
    chatRequested: 'chat requested',
    chatWidgetOpened: 'chat widget opened',
    closedTitlesClicked: 'closed titles clicked',
    dueSoonTitlesClicked: 'due soon titles clicked',
    recentlySoldTitlesClicked: 'recently sold titles clicked',
    titleAddNoteButtonClicked: 'title add note button clicked',
    titleBannerDismissed: 'title banner dismissed',
    titleBillOfSalesCilicked: 'title download bill of sales clicked',
    titleDownloadClicked: 'title download clicked',
    titleHubBannerClosed: 'title hub banner closed',
    titleLabelPrinted: 'title label printed',
    titleNoteAdded: 'title note added',
    titleNoteCanceled: 'title note canceled',
    titleOptionClicked: 'title option clicked',
    titleTrackPackageClicked: 'title track package clicked',
    titleUploadCanceled: 'title upload canceled',
    titleUploadDocumentClicked: 'title upload document button clicked',
    titleUploadFileBrowsed: 'title upload file browsed',
    titleUploadFileDeleted: 'title upload file deleted',
    titleUploadSubmitted: 'title upload submitted',
    titleVehicleImageClosed: 'title vehicle image closed',
    titleVehicleImageOpened: 'title vehicle image opened',
    titleViewDetailsClicked: 'title view details clicked',
    titlesClosedStatusViewed: 'title status closed page viewed',
    titlesConfirmAndGenerateShippingLabelButtonClicked: 'title confirm and generate shipping label button clicked',
    titlesExportModalOpened: 'title export modal opened',
    titlesGenerateShippingLabelButtonClicked: 'title generate shipping label button clicked',
    titlesHeaderClicked: 'title logo header clicked',
    titlesHubOpened: 'titles hub clicked and viewed',
    titlesOpenStatusViewed: 'title status opened page viewed',
    titlesShippingLabelCreated: 'title shipping label created',
    titlesShippingLabelFailed: 'title shipping label failed to generate',
    urgentTitlesClicked: 'urgent titles clicked',

  },
  titleNoticeSubmitted: '48 hour title notice submitted',
  titleProblemSubmitted: 'title problem submitted',
  titleStatusSubmitted: 'title status submitted',
  tours: {
    finished: 'tour finished',
    next: 'tour next step clicked',
    prev: 'tour previous step clicked',
    skipped: 'tour skipped',
    started: 'tour started',
  },
  transportCheckoutAddressSelected: 'transport checkout address selected',
  transportCheckoutLearnMoreClicked: 'transport checkout learn more clicked',
  transportOptionSelected: 'transport option selected',
  transportationHub: {
    transportationHubGatePassDeleteFileClicked: 'When a user clicks to delete gate pass',
    transportationHubGatePassDownloadButtonClicked: 'When a user clicks to download a gate pass',
    transportationHubGatePassUploadFileClicked: 'When a user clicks to add a new gate pass',
    transportationHubGetMyQuoteNowClicked: 'transportation hub get my quote now clicked',
    transportationHubGetMyQuoteNowVinEntered: 'transportation hub get my quote now vin entered',
    transportationHubGetQuoteBackClicked: 'transportation hub get quote back clicked',
    transportationHubGetQuoteDealerDropdownChanged: 'transportation hub get quote dealer dropdown changed',
    transportationHubGetQuoteDeliveryZipEntered: 'transportation hub get quote delivery zip entered',
    transportationHubGetQuotePickupZipEntered: 'transportation hub get quote pickup zip entered',
    transportationHubGetQuoteXClicked: 'transportation hub get quote x clicked',
    transportationHubMobileBannerGetQuoteClicked: 'transportation hub mobile banner 01 get quote clicked',
    transportationHubOrderDetailsViewed: 'transportation hub order details viewed',
    transportationHubOrdersSearched: 'transportation hub orders searched',
    transportationHubPaginated: 'transportation hub paginated',
    transportationHubPlaceOrderClicked: 'transportation hub place order clicked',
    transportationHubReviewOrderClicked: 'transportation hub review order clicked',
    transportationHubRowsPerPageChanged: 'transportation hub rows per page changed',
    transportationHubSortOrderChanged: 'transportation hub sort order changed',
    transportationHubStartANewOrderClicked: 'transportation hub start a new order clicked',
    transportationHubStatusFilterChanged: 'transportation hub status filter changed',
    transportationHubVerticalRightSideGetQuoteClicked: 'transportation hub vertical right side banner 01 get quote clicked',
    transportationHubViewed: 'transportation hub viewed',
    transportationRefreshPromptShowed: 'transportation hub show refresh prompt',
  },
  transportationStatusViewed: 'transportation status viewed',
  unwindArbitrationPlanPolicyViewed: 'unwind arbitration plan policy viewed',
  userMenuSelected: 'user menu selected',
  vinCopyClicked: 'vin copy clicked',
  virtualLiftClosed: 'virtual lift closed',
  virtualLiftExpanded: 'virtual lift expanded',
};
